'use client'
import { Menu } from 'lucide-react'
import dynamic from 'next/dynamic'
import { useState } from 'react'

import { Button } from '@/blocks/components/ui/button'
import { PublicHomeDto } from '@/server/public-api/types'

const Sidebar = dynamic(() => import('@/blocks/layouts/header/Sidebar'))
const MobileNav = ({ home }: { home: PublicHomeDto }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [isAnimatedDrawerOpen, setIsAnimatedDrawerOpen] = useState(false)
  return (
    <section className='md:hidden'>
      <Button
        variant='ghost'
        size='sm'
        aria-label='Open menu'
        onClick={() => {
          setIsDrawerOpen(true)
          setIsAnimatedDrawerOpen(true)
        }}
      >
        <Menu />
      </Button>

      {isAnimatedDrawerOpen && (
        <Sidebar
          home={home}
          isOpen={isDrawerOpen}
          setOpenChange={setIsDrawerOpen}
          setIsAnimatedDrawerOpen={setIsAnimatedDrawerOpen}
        />
      )}
    </section>
  )
}

export default MobileNav
